import styled from 'styled-components';

export const ViewJobPageSidebarPaginationHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  > *:first-child {
    /* When the user selects the first search hit, we want to show the "save search" button
     * This number doesn't have to be exact, it just needs to be big enough to reach the top of the scrolling container
     */
    scroll-margin-top: 200px;
  }

  > *:not(:first-child) {
    scroll-margin-top: 8px;
  }
`;
